import { Injectable, inject } from '@angular/core';

import { FormPostService } from '@fcom/core';
import { FinnairBoundItem, FinnairDisruptedBoundItem, FinnairOrder } from '@fcom/dapi/api/models';

@Injectable({ providedIn: 'root' })
export class RedirectService {
  private formPostService = inject(FormPostService);

  redirectToCheckIn(
    order: FinnairOrder,
    bound?: FinnairBoundItem | FinnairDisruptedBoundItem,
    openAsBlank = false
  ): void {
    const eligiblity = order.eligibilities.checkIn.find(
      (eligibility) => (bound && eligibility.id === bound.id) || (!bound && eligibility.isAllowedToUseCheckIn)
    );
    if (!eligiblity) {
      throw new Error('Unable to find check-in redirection form from backend');
    }

    this.formPostService.post(
      eligiblity.redirect.url,
      eligiblity.redirect.params.reduce((params, param) => {
        params[param.name] = param.value;
        return params;
      }, {}),
      eligiblity.redirect.method,
      openAsBlank ? '_blank' : '_self'
    );
  }
}
